function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "coalitionicon2");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 58,
  height: 42.3076923
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: 0,
  y: 0,
  width: 58,
  height: 42.3076923,
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-3",
  x: 6.85454545,
  y: 48.6538462,
  width: 44.2909091,
  height: 6.34615385
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: 0,
  y: 0,
  width: 44.2909091,
  height: 6.34615385,
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-5",
  x: 23.7272727,
  y: 41.25,
  width: 10.5454545,
  height: 12.6923077
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: 0,
  y: 0,
  width: 10.5454545,
  height: 12.6923077,
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "coalitionicon2"
}, /*#__PURE__*/React.createElement("use", {
  id: "Rectangle-32",
  stroke: "#60B0FF",
  mask: "url(#mask-2)",
  strokeWidth: 10.4819277,
  fill: "#FFFFFF",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle-34",
  stroke: "#60B0FF",
  mask: "url(#mask-4)",
  strokeWidth: 1.04819277,
  fill: "#60B0FF",
  xlinkHref: "#path-3"
}), /*#__PURE__*/React.createElement("use", {
  id: "Rectangle-33",
  stroke: "#60B0FF",
  mask: "url(#mask-6)",
  strokeWidth: 1.04819277,
  fill: "#60B0FF",
  xlinkHref: "#path-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.8511829,31.6343234 C16.6035161,31.6343234 14.1293691,30.7311397 12.4286679,28.9247451 C10.7279666,27.1183506 9.8776287,24.5529244 9.8776287,21.2283897 C9.8776287,19.5757308 10.1370538,18.100851 10.6559118,16.803706 C11.1747698,15.5065609 11.8857868,14.4112104 12.7889841,13.5176216 C13.6921814,12.6240328 14.7683152,11.946645 16.0174179,11.4854379 C17.2665205,11.0242308 18.6212961,10.7936307 20.0817853,10.7936307 C20.9273317,10.7936307 21.6959987,10.8560849 22.3878094,10.9809951 C23.0796201,11.1059054 23.6849454,11.2500305 24.2038034,11.4133747 C24.7226614,11.5767188 25.1550366,11.7448648 25.5009419,11.9178174 C25.8468473,12.0907701 26.0966641,12.2252868 26.2503998,12.3213716 L24.9532612,15.9533596 C24.3383184,15.6266712 23.6224972,15.3480294 22.8057763,15.1174259 C21.9890553,14.8868223 21.0618508,14.7715222 20.0241347,14.7715222 C19.332324,14.7715222 18.6549362,14.8868223 17.991951,15.1174259 C17.3289657,15.3480294 16.7428571,15.7179504 16.2336076,16.2272 C15.7243581,16.7364495 15.3160037,17.3946206 15.0085323,18.2017331 C14.7010609,19.0088456 14.5473275,19.988896 14.5473275,21.1419138 C14.5473275,22.0643281 14.648215,22.9242743 14.8499932,23.7217783 C15.0517713,24.5192823 15.3784548,25.2062784 15.8300534,25.7827873 C16.281652,26.3592962 16.8725648,26.8156922 17.6028094,27.1519891 C18.333054,27.488286 19.2170211,27.6564319 20.2547371,27.6564319 C20.9081139,27.6564319 21.4942225,27.6179985 22.0130805,27.5411307 C22.5319385,27.4642628 22.9931387,27.3729836 23.396695,27.2672903 C23.8002512,27.161597 24.1557597,27.0414928 24.4632311,26.9069741 C24.7707025,26.7724553 25.0493443,26.6475469 25.2991648,26.5322451 L26.5386528,30.1354078 C25.904493,30.5197471 25.0109176,30.8656472 23.8578998,31.1731186 C22.704882,31.48059 21.369323,31.6343234 19.8511829,31.6343234 L19.8511829,31.6343234 Z M32.4766648,21.2283897 C32.4766648,22.2084549 32.5967691,23.0924219 32.8369811,23.8803174 C33.0771932,24.6682129 33.4230933,25.3456007 33.8746919,25.9125012 C34.3262906,26.4794016 34.87877,26.9165809 35.5321468,27.2240524 C36.1855235,27.5315238 36.9349739,27.6852572 37.7805203,27.6852572 C38.6068497,27.6852572 39.3514959,27.5315238 40.0144811,27.2240524 C40.6774663,26.9165809 41.2347499,26.4794016 41.6863486,25.9125012 C42.1379472,25.3456007 42.4838474,24.6682129 42.7240594,23.8803174 C42.9642715,23.0924219 43.0843757,22.2084549 43.0843757,21.2283897 C43.0843757,20.2483246 42.9642715,19.3595533 42.7240594,18.5620494 C42.4838474,17.7645454 42.1379472,17.0823534 41.6863486,16.515453 C41.2347499,15.9485525 40.6774663,15.5113732 40.0144811,15.2039018 C39.3514959,14.8964303 38.6068497,14.7426969 37.7805203,14.7426969 C36.9349739,14.7426969 36.1855235,14.9012345 35.5321468,15.2183144 C34.87877,15.5353943 34.3262906,15.9773778 33.8746919,16.5442783 C33.4230933,17.1111787 33.0771932,17.7933707 32.8369811,18.5908747 C32.5967691,19.3883786 32.4766648,20.2675415 32.4766648,21.2283897 L32.4766648,21.2283897 Z M47.7252492,21.2283897 C47.7252492,22.9386995 47.4706282,24.4424043 46.9613787,25.7395494 C46.4521292,27.0366944 45.7555247,28.1224365 44.8715444,28.9968084 C43.987564,29.8711802 42.9354511,30.5293514 41.7151739,30.9713415 C40.4948967,31.4133317 39.1833586,31.6343234 37.7805203,31.6343234 C36.4161159,31.6343234 35.1285986,31.4133317 33.9179299,30.9713415 C32.7072612,30.5293514 31.6503441,29.8711802 30.7471468,28.9968084 C29.8439495,28.1224365 29.1329325,27.0366944 28.6140745,25.7395494 C28.0952165,24.4424043 27.8357913,22.9386995 27.8357913,21.2283897 C27.8357913,19.51808 28.1048248,18.0143751 28.6428998,16.7172301 C29.1809748,15.420085 29.9064043,14.3295387 30.81921,13.4455584 C31.7320158,12.5615781 32.7889329,11.8986028 33.9899932,11.4566126 C35.1910534,11.0146224 36.4545498,10.7936307 37.7805203,10.7936307 C39.1449247,10.7936307 40.4324419,11.0146224 41.6431106,11.4566126 C42.8537793,11.8986028 43.9106965,12.5615781 44.8138938,13.4455584 C45.717091,14.3295387 46.428108,15.420085 46.946966,16.7172301 C47.4658241,18.0143751 47.7252492,19.51808 47.7252492,21.2283897 L47.7252492,21.2283897 Z",
  id: "CO",
  fill: "#07081C"
})));

var SvgDeliveryCoalitionExc = function SvgDeliveryCoalitionExc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "55px",
    viewBox: "0 0 58 55",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeliveryCoalitionExc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delivery-COALITION_EXC.3755fa8f.svg";
export { ForwardRef as ReactComponent };